import { MissingScheduleAResidualSplitProfileTypes } from "types";

const useMissingScheduleAResidualSplitProfileDdlColumn = () => {
	return {
		name: "missing",
		type: "select" as const,
		loadOptions: () => ({
			options: MissingScheduleAResidualSplitProfileTypes.getOptions(),
			hasMore: false,
		}),
		getOptionLabel: option => option.displayName,
		getOptionValue: option => option.value,
		placeholder: "Missing",
	};
};

export default useMissingScheduleAResidualSplitProfileDdlColumn;
